import dynamic from "next/dynamic"
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Link from "next/link";
import { stripTags } from "../../config/helpers";

const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));


const Venue = (props) => {
    const {
        template_page_settings,
        landing_page_data,
        venue
    } = props;

    let renderFacts = true;

    if(!venue.address && !venue.telephone && !venue.capacity && !venue.link && !venue.owner && !venue.is_it_for_me){
        renderFacts = false;
    }

    return (
        <BoxContainer className="mt-4" template_page_settings={template_page_settings}>
            <Grid spacing={5} container>
                <Grid xs={12} lg={renderFacts ? 8 : 12} item>
                <Typography className="f-size_5 text-center" component="h1" variant="h1">{venue.name}</Typography>
                    <div dangerouslySetInnerHTML={{ __html: venue.intro}}/>
                    <div dangerouslySetInnerHTML={{ __html: venue.tell_me_more}}/>
                </Grid>

                {renderFacts && <Grid xs={12} lg={4} item>
                  <Typography className="f-size_5" component="h5" variant="h5">Key Facts</Typography>
                  {venue.address && <Typography component="p" variant="p"><strong>Address: </strong>{venue.address}</Typography>}
                  <Typography component="p" variant="p"><strong>Telephone: </strong>{venue.telephone}</Typography>
                  <Typography component="p" variant="p"><strong>Capacity: </strong>{venue.capacity}</Typography>
                  <Typography component="p" variant="p">
                      <strong>Website: </strong>
                    <Link target="_blank" href={`http://${venue.link}`}>{venue.link}</Link>
                  </Typography>
                  <Typography component="p" variant="p"><strong>Owner: </strong>{venue.owner}</Typography>
                  
                  {venue.is_it_for_me && <div className="mt-3">
                    <Typography className="f-size_5" component="h5" variant="h5">Is It For Me?</Typography>
                    <Typography>{stripTags(venue.is_it_for_me)}</Typography>  
                  </div>}
                </Grid>}
            </Grid>
        </BoxContainer>
    )
}

export default Venue